export const menuItems = 
[
  {
    "id": 1,
    "name": "API Library",
    "url": "/apis",
    "subMenu": [
      {
        "id": 2,
        "name": "AMD Platform APIs",
        "subMenu": [
          {
            "id": 3,
            "name": "API Background",
            "url": "/docs/oamd/intro"
          },
          {
            "id": 4,
            "name": "AMD Use Cases",
            "subMenu": [
              {
                "id": 5,
                "name": "Get User Token",
                "url": "/docs/oamd/use-cases/get-user-token"
              },
              {
                "id": 6,
                "name": "Get Program and Project ID",
                "url": "/docs/oamd/use-cases/get-program-or-project-id"
              },
              {
                "id": 7,
                "name": "Search for Samples",
                "url": "/docs/oamd/use-cases/search-for-samples"
              },
              {
                "id": 8,
                "name": "Create Samples",
                "url": "/docs/oamd/use-cases/create-samples"
              },
              {
                "id": 9,
                "name": "Update Metadata on Sample",
                "url": "/docs/oamd/use-cases/update-metadata-on-sample"
              },
              {
                "id": 10,
                "name": "Upload Genomic Data",
                "url": "/docs/oamd/use-cases/upload-genomic-data"
              },
              {
                "id": 11,
                "name": "Run Workflow",
                "url": "/docs/oamd/use-cases/run-workflow"
              },
              {
                "id": 12,
                "name": "View Workflow Runs",
                "url": "/docs/oamd/use-cases/view-workflow-runs"
              },
              {
                "id": 13,
                "name": "Download Workflow Run Results",
                "url": "/docs/oamd/use-cases/download-workflow-run-results"
              },
              {
                "id": 14,
                "name": "Authenticate user against Azure and get AMDP Token",
                "url": "/docs/oamd/use-cases/get-auth-token"
              }
            ]
          },
          {
            "id": 15,
            "name": "API Specifications",
            "subMenu": [
              {
                "id": 16,
                "name": "Schemas",
                "url": "/docs/oamd/api/sample-service"
              },
              {
                "id": 17,
                "name": "Schemas",
                "url": "/docs/oamd/api/user-service"
              },
              {
                "id": 18,
                "name": "Schemas",
                "url": "/docs/oamd/api/workflow-service"
              }
            ]
          }
        ]
      },
      {
        "id": 19,
        "name": "NIO Autocoder",
        "subMenu": [
          {
            "id": 20,
            "name": "Changelog",
            "url": "/docs/nio-autocoder/CHANGELOG"
          },
          {
            "id": 21,
            "name": "Access",
            "url": "/docs/nio-autocoder/access"
          },
          {
            "id": 22,
            "name": "NIO Autocoder API",
            "url": "/docs/nio-autocoder/api"
          },
          {
            "id": 23,
            "name": "API Guidance",
            "url": "/docs/nio-autocoder/guidance"
          },
          {
            "id": 24,
            "name": "Purpose",
            "url": "/docs/nio-autocoder/purpose"
          },
          {
            "id": 25,
            "name": "API Specifications",
            "url": "/docs/nio-autocoder/swagger/nio-autocoder-1-0-0"
          }         
        ]
      },
      // {
      //   "id": 25,
      //   "name": "DEX Upload API",
      //   "subMenu": [
      //     {
      //       "id": 26,
      //       "name": "API Overview",
      //       "url": "/docs/dex-uploadapi/api-overview"
      //     },
      //     {
      //       "id": 27,
      //       "name": "Updates, Version, & Change History",
      //       "url": "/docs/dex-uploadapi/change-history"
      //     },
      //     {
      //       "id": 28,
      //       "name": "Documentation",
      //       "url": "/docs/dex-uploadapi/documentation"
      //     },
      //     {
      //       "id": 29,
      //       "name": "Getting Started",
      //       "url": "/docs/dex-uploadapi/get-started"
      //     },
      //     {
      //       "id": 30,
      //       "name": "Questions, Help & Support",
      //       "url": "/docs/dex-uploadapi/help-and-support"
      //     }
      //   ]
      // },
      {
        "id": 31,
        "name": "MVPS Reports External API",
        "subMenu": [
          {
            "id": 311,
            "name": "Documentation",
            "url": "/docs/mvps-external-api/documentation"
          },
          {
            "id": 312,
            "name": "API Specifications",
            "url": "/docs/mvps-external-api/swagger/mvps-rpts-1-0-0"
          }
        ]
      },
      {
        "id": 33,
        "name": "AMDP API",
        "subMenu": [
          {
            "id": 34,
            "name": "Sample Service",
            "url": "/docs/amdp-api/sample-service"
          },
          {
            "id": 35,
            "name": "User Service",
            "url": "/docs/amdp-api/user-service"
          },
          {
            "id": 36,
            "name": "Workflow Service",
            "url": "/docs/amdp-api/workflow-service"
          },
        ]
      },
      {
        "id": 37,
        "name": "Admin Codes API",
        "url": "/docs/ews-admincodes-api/documentation",
        "subMenu" : [
          {
            "id": 38,
            "name": "Purpose",
            "url" : "/docs/ews-admincodes-api/purpose"
          },
          {
            "id": 39,
            "name": "API Guidance",
            "url": "/docs/ews-admincodes-api/api-guidance" 
          },
          {
            "id": 40,
            "name": "Access",
            "url": "/docs/ews-admincodes-api/access" 
          },
          {
            "id": 41,
            "name": "Changelog",
            "url": "/docs/ews-admincodes-api/CHANGELOG" 
          },
          {
            "id": 42,
            "name": "API Specifications",
            "url": "/docs/ews-admincodes-api/swagger/ews-admincodes-api-1-0-0"
          }
        ],
      },
      {
        "id": 42,
        "name": "Calendar API",
        "url": "/docs/ews-calendar-api/documentation",
        "subMenu" : [
          {
            "id": 43,
            "name": "Purpose",
            "url" : "/docs/ews-calendar-api/purpose"
          },
          {
            "id": 44,
            "name": "API Guidance",
            "url": "/docs/ews-calendar-api/api-guidance" 
          },
          {
            "id": 45,
            "name": "Access",
            "url": "/docs/ews-calendar-api/access" 
          },
          {
            "id": 46,
            "name": "Changelog",
            "url": "/docs/ews-calendar-api/CHANGELOG" 
          },
          {
            "id": 47,
            "name": "API Specifications",
            "url": "/docs/ews-calendar-api/swagger/dso-ews-calendar-api-1-0-0"
          }
 
        ],
      },
      // commenting out due to lack of information for this API.
      // {
      //   "id": 47,
      //   "name": "Email API",
      //   "url": "/docs/ews-email-api/purpose",
      //   "subMenu" : [
      //     {
      //       "id": 48,
      //       "name": "Purpose",
      //       "url" : "/docs/ews-email-api/purpose"
      //     },
      //     {
      //       "id": 49,
      //       "name": "API Guidance",
      //       "url": "/docs/ews-email-api/api-guidance" 
      //     },
      //     {
      //       "id": 50,
      //       "name": "Access",
      //       "url": "/docs/ews-email-api/access" 
      //     },
      //     {
      //       "id": 51,
      //       "name": "Changelog",
      //       "url": "/docs/ews-email-api/CHANGELOG" 
      //     }
      //   ],
      // },
      {
        "id": 52,
        "name": "Lookup API (EWS)",
        "url": "/docs/ews-lookup-api/documentation",
        "subMenu" : [
          {
            "id": 53,
            "name": "Purpose",
            "url" : "/docs/ews-lookup-api/purpose"
          },
          {
            "id": 54,
            "name": "API Guidance",
            "url": "/docs/ews-lookup-api/api-guidance" 
          },
          {
            "id": 55,
            "name": "Access",
            "url": "/docs/ews-lookup-api/access" 
          },
          {
            "id": 56,
            "name": "Changelog",
            "url": "/docs/ews-lookup-api/CHANGELOG" 
          },
          {
            "id": 57,
            "name": "API Specifications",
            "url": "/docs/ews-lookup-api/swagger/dso-ews-lookup-api-1-0-0"
          }
 
        ],
      },
      {
        "id": 57,
        "name": "Person API (EWS)",
        "url": "/docs/ews-person-api/documentation",
        "subMenu" : [
          {
            "id": 58,
            "name": "Purpose",
            "url" : "/docs/ews-person-api/purpose"
          },
          {
            "id": 59,
            "name": "API Guidance",
            "url": "/docs/ews-person-api/api-guidance" 
          },
          {
            "id": 60,
            "name": "Access",
            "url": "/docs/ews-person-api/access" 
          },
          {
            "id": 61,
            "name": "Changelog",
            "url": "/docs/ews-person-api/CHANGELOG" 
          },
          {
            "id": 62,
            "name": "API Specifications",
            "url": "/docs/ews-person-api/swagger/dso-asb-person-api-1-0-0"
          }
 
        ],
      },
      {
        "id": 62,
        "name": "Data Scanner API",
        "subMenu" : [
          {
            "id": 63,
            "name": "Documentation",
            "url" : "/docs/data-scanner-api/documentation"
          },
        ],
      },
      {
        "id": 70,
        "name": "HAIC CDI API",
        "url": "/docs/haic-cdi-api/purpose",
        "subMenu": [
          // {
          //   "id": 71,
          //   "name": "Documentation",
          //   "url": "/docs/haic-cdi-api/documentation"
          // },
          {
            "id": 72,
            "name": "Purpose",
            "url": "/docs/haic-cdi-api/purpose"
          },
          {
            "id": 73,
            "name": "Access",
            "url": "/docs/haic-cdi-api/access"
          },
          {
            "id": 74,
            "name": "API Guidance",
            "url": "/docs/haic-cdi-api/guidance"
          },
          {
            "id": 75,
            "name": "API Info",
            "url": "/docs/haic-cdi-api/api"
          },
          {
            "id": 76,
            "name": "Changelog",
            "url": "/docs/haic-cdi-api/CHANGELOG"
          },
          {
            "id": 77,
            "name": "API Specifications",
            "url": "/docs/haic-cdi-api/swagger/haic-cdi-api-1-0-0"
          },
        ],
      },
    ]
  }
]
;
